/**
 * Toggleable Formatter.
 * Renders a circular toggle button that updates a boolean field via AJAX.
 * @param {*} value
 * @param {*} row
 * @param {string} field
 * @param {string} url
 * @returns {string}
 */
window.toggleableFormatter = function(value, row, field, url) {
    let isOn = value === 1 || value === '1' || value === true || value === 'TRUE';
    let cls = isOn ? 'is-on' : 'is-off';
    let icon = isOn ? 'fa-check' : 'fa-xmark';
    let urlAttr = url ? ' data-toggle-url="' + url + '"' : '';

    return '<button type="button" class="toggle-pill ' + cls + '" '
        + 'data-toggle-field="' + field + '" '
        + 'data-toggle-id="' + row.id + '"' + urlAttr + ' '
        + 'aria-pressed="' + (isOn ? 'true' : 'false') + '">'
        + '<i class="fa ' + icon + '"></i>'
        + '</button>';
};

$(function () {
    $(document).on('click', '.toggle-pill', function () {
        let $btn = $(this);
        if ($btn.prop('disabled')) return;

        let field = $btn.data('toggle-field');
        let url = $btn.data('toggle-url');
        if (!url) return;

        $btn.prop('disabled', true);
        axios.patch(url, { field: field }).then(function (res) {
            let isOn = res.data && (res.data.value === 1 || res.data.value === '1');
            $btn.removeClass('is-on is-off').addClass(isOn ? 'is-on' : 'is-off');
            $btn.attr('aria-pressed', isOn ? 'true' : 'false');
            $btn.find('i').removeClass('fa-check fa-xmark').addClass(isOn ? 'fa-check' : 'fa-xmark');
        }).catch(function (err) {
            Swal.fire({
                icon: 'error',
                title: __('Error'),
                text: (err && err.response && err.response.data && err.response.data.message)
                    ? err.response.data.message
                    : __('Failed to update')
            });
        }).finally(function () {
            $btn.prop('disabled', false);
        });
    });
});
